import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import moment from 'moment'
import { toast } from 'react-hot-toast'
import { ButtonFilled, ButtonFilledAutoWidth } from '../../../components/button'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { CreateDepartmentService, UpdateDepartmentService } from '../../../services/DepartmentServices'
import { useNavigate, useLocation } from 'react-router-dom'
import { MobileBackOption } from '../../../components/appbars/mobile/DashboardMobile'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { message,Select } from 'antd'
import { CreateFollowupService, UpdateFollowupService } from '../../../services/admin/FollowupServices'
import { CreateDigitalCardService, UpdateDigitalCardService } from '../../../services/admin/DigitalCardServices'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { GetDigitalCardDistributorSearchService } from '../../../services/admin/DigitalCardDistributorServices'

function DigitalCardCE() {
 
  const [data,setdata] = useState({card_no:'',days:'',amount:'',type:'',customer:'',used:false,remarks:'',distributor:'',count:''});  
  const [error,seterror] = useState({card_no:'',days:'',amount:'',type:'',customer:'',used:'',remarks:'',distributor:'',count:''}); 
  
  const {state} = useLocation();
  const pathname = window.location.pathname.split('/').pop();
  const navigate = useNavigate();

  const [distributors,setdistributors] = useState([])

  const typeArr = [{label:'Free',value:'free'},{label:'Paid',value:'paid'}]
  const amountArr = [0,4500,4700,4800,4900,5000].map((v)=>({label:`₹${v}`,value:v}))


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      let d = {...data,...state}
      if(state?.distributor){
        d.distributor = {label: state?.distributor?.name === '' ? ('No name added ' + state?.distributor?.phone) : state?.distributor?.name + ' ' + state?.distributor?.phone, value: state?.distributor?._id}
      }

      console.log("state",state,"data",d)

      if(state?.amount){
        d.amount = amountArr.find((f)=>f.value == state?.amount)
      }

      console.log("d",d)
      setdata({...data,...d})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function searchData(val,type){
    
      if(type === 'distributor'){
        const response = await GetDigitalCardDistributorSearchService(val,1, '', '', '','All Data','',val)
        let arr = []
        response?.data?.datas?.forEach((d)=>{
          arr?.push({label:d?.name === '' ? ('No name added ' + d?.phone) : d?.name + ' ' + d?.phone,value:d?._id})
        })
        setdistributors(arr)
      }
  
      
      
    }

  async function submitform(){
    if(!data.days){
        seterror({...error,days:'Days field is required *'})
    }else if(!data.amount && data.amount === ''){
        seterror({...error,amount:'Amount field is required *'})
    }else if(!data.type){
        seterror({...error,type:'Type field is required *'})
    }else{
        if(state?._id === undefined || state?._id === null){
        let send_data = {...data}
        send_data.type = typeArr.find((t)=>t.value === data.type)?.value
        send_data.amount = data?.amount?.value ?? 0
        if(send_data.customer === ''){
          delete send_data.customer
        }else{
          send_data.customer = send_data.customer.value
        }
        if(send_data.distributor === ''){
          delete send_data.distributor
        }else{
          send_data.distributor = send_data.distributor.value
        }
        const response = await CreateDigitalCardService(send_data)
        if (response.status === 201) {
          resetform()
          toast.success('Digital Card Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        send_data.amount = data?.amount?.value ?? 0
        send_data.type = typeArr.find((t)=>t.value === data.type)?.value
        delete send_data.customer
        if(send_data.distributor === ''){
          delete send_data.distributor
        }else{
          send_data.distributor = send_data.distributor.value
        }
        const response = await UpdateDigitalCardService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Digital Card Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }


  function resetform(){
    setdata({card_no:'',days:'',amount:'',type:'',customer:'',used:false,remarks:'',distributor:'',count:''})
    seterror({card_no:'',days:'',amount:'',type:'',customer:'',used:'',remarks:'',distributor:'',count:''})
  }
  
  async function handleSelect(e,e1){
    if(e1 === 'distributor'){
      console.log("e",e,"distributors.find((t)=>t.value === e)",distributors.find((t)=>t.value === e))
      setdata({...data,distributor:distributors.find((t)=>t.value === e)})
      seterror({...error,distributor:''})
    }
    if(e1 === 'type'){
      setdata({...data,type:typeArr.find((t)=>t.value === e)?.value})
      seterror({...error,type:''})
    }
    if(e1 === 'amount'){
      setdata({...data,amount:amountArr.find((t)=>t.value === e)?.value})
      seterror({...error,amount:''})
    }
  }

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Digital Card</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Digital Card</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Card Number'}  
            variant="standard"
            name="card_no"
            type="number"
            error={error.card_no}
            value={data.card_no}
            handlechange={handlechange}
            placeholder="Enter your card number"
            disabled={pathname === 'edit'}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         {(state?._id === null || state?._id === undefined) &&
         <TextInput 
            label={'Count'}  
            variant="standard"
            name="count"
            type="number"
            error={error.count}
            value={data.count}
            handlechange={handlechange}
            placeholder="Enter your count"
            disabled={pathname === 'edit'}
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>}    

          <TextInput 
            label={'Days'}  
            variant="standard"
            name="days"
            type="number"
            error={error.days}
            value={data.days}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>  

          <div>
             <h6 className='text-[11px] mb-1 mt-2'>Amount </h6>
                <Select
                  value={data.amount}
                  filterOption={false}
                  bordered={false}
                  placeholder=""
                  onChange={(e)=>handleSelect(e,'amount')}
                  options={amountArr}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                  />
            </div>
            {error.amount && <h6 className='text-[10px] text-red-500 mt-1'>{error.amount}</h6>}

            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Type </h6>
                <Select
                  value={data.type} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'type')} 
                  options={typeArr} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <TextAreaInput1 
              label={'Remarks'}  
              variant="standard"
              name="remarks"
              type="text"
              error={error.remarks}
              value={data.remarks}
              handlechange={handlechange}
              placeholder=""
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>

            <div onClick={()=>setdata({...data,used:!data.used})} className='flex items-center mt-2 mr-2'>
                          {data?.used ?  <BiCheckboxSquare size={22} className='text-slate-800' />  : <BiCheckbox size={22} className='text-slate-300'  /> }
                          <h6 className="text-[10px] font-[600] ml-1">Used</h6>
                        </div>

            {data?.used && state?.customer &&
            <div className='mt-2 border border-slate-200 rounded-md p-2'>
              <h6 className='text-[11px] font-[700] mb-1'>User Info</h6>
              <h6 className='text-[10px] mb-1'><span className='font-[600]'>Name</span> : {state?.customer?.name || 'No name added'}</h6>
              <h6 className='text-[10px] mb-1'><span className='font-[600]'>Mobile</span> : {state?.customer?.mobile || '-'}</h6>
              <h6 className='text-[10px]'><span className='font-[600]'>Subscription Expires On</span> : {state?.createdAt && data?.days ? moment(state.createdAt).add(Number(data.days),'days').format('DD MMM YYYY') : '-'}</h6>
            </div>}


                        <div>
             <h6 className='text-[11px] mb-1 mt-2'>Distributor Info </h6>
                <Select
                  value={data.distributor} 
                  filterOption={false}
                  showSearch
                  bordered={false}
                  placeholder="" 
                  onChange={(e)=>handleSelect(e,'distributor')} 
                  onSearch={(e)=>searchData(e,'distributor')}
                  options={distributors} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE DIGITAL CARD" : "ADD DIGITAL CARD"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default DigitalCardCE